// export const GPT_URL = "//securepubads.g.doubleclick.net/tag/js/gpt.js"
export const GPT_URL = "//securepubads.g.doubleclick.net/tag/js/gpt.js"
export const PREBID_URL = "https://prebid.reworldmediafactory.com/thefinefinance.com/script.min.js"
export const ADUNIT = "/46980923/thefinefinance.com-web"

export const GTM_KEY = "GTM-5B462R4"
export const GTAG_KEY = "UA-213529084-1"